import { render, staticRenderFns } from "./multichoice-options-dropdown.vue?vue&type=template&id=b09e075a&scoped=true&"
import script from "./multichoice-options-dropdown.vue?vue&type=script&lang=js&"
export * from "./multichoice-options-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./multichoice-options-dropdown.vue?vue&type=style&index=0&id=b09e075a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09e075a",
  null
  
)

component.options.__file = "multichoice-options-dropdown.vue"
export default component.exports